import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthorizationData } from '@kaseya-shared';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThirdPartySsoService {
  private readonly httpClient = inject(HttpClient);

  getAuthorizationData(ssoToken: string): Observable<AuthorizationData> {
    const url = 'api/v2/login/sso';

    return this.httpClient.post<AuthorizationData>(environment.portalApiUrl + url, null, {
      headers: {
        Authorization: `Bearer ${ssoToken}`,
      },
    });
  }
}
